export function isTimeDifferenceLessThanNMilliseconds(dateStr1: string, dateStr2: string, milli: number): boolean {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    // Calculate the time difference in milliseconds
    const timeDifference = Math.abs(date1.getTime() - date2.getTime());

    return timeDifference < milli;
}
